// A whole-number company setting typed into a box. Returns the number, or null when the box is
// blank or is not a whole number, so the screen refuses to save instead of storing 0 (an empty
// box is Number("") === 0) or null (a word is NaN).
export function wholeNumberDraft(draft) {
  const text = String(draft ?? "").trim();
  return /^-?\d+$/.test(text) ? Number(text) : null;
}
